import { PAGE_COUNTRY_MAP } from '@/src/constants/domain'

/**
 * Maps hostname to GTM page_country code
 * @param hostname - The hostname from window.location.hostname
 * @returns GTM country code ('global', 'eg', 'ae')
 */
export const getGtmPageCountry = (hostname: string): string => {
    if (!hostname) return 'global'

    const origin = `https://${hostname.toLowerCase()}`
    const pageCountry = PAGE_COUNTRY_MAP[origin as keyof typeof PAGE_COUNTRY_MAP]

    return pageCountry || 'global'
}

const COUNTRY_CODE_NAME_MAP: Record<string, string> = {
    ae: 'United Arab Emirates',
    om: 'Oman',
    qa: 'Qatar',
    bh: 'Bahrain',
    kw: 'Kuwait',
    sa: 'Saudi Arabia',
    eg: 'Egypt',
    global: 'Global'
}

/**
 * Returns the display name of the country based on hostname
 * @param hostname - The hostname from window.location.hostname
 * @returns Country display name ('UAE', 'Oman', 'Global', etc.)
 */
export const getGtmPageCountryName = (hostname: string): string => {
    const code = getGtmPageCountry(hostname)
    return COUNTRY_CODE_NAME_MAP[code] || 'Global'
}

